/* eslint-disable max-lines-per-function */
import { Island } from '@rta/rta-blueprint-library';
import { ComponentController as BpController, DisplayMode } from '@rta/rta-blueprint-component';
import { Button, Grid, HStack, Text, Tooltip, VStack } from '@chakra-ui/react';

import { Controller } from '@context';
import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, showPanelFeature, useDisplayOverheadModeFeature, useDisplayPanelModeFeature, useDisplaySkuOverheadModeFeature } from '@features';

import type { JSX } from "react";

export const NavigationActionPanel = (): JSX.Element => {
	const [controller] = useDesign<BpController>();

	let island: Island | null = null;
	if (controller?.instanceOf === 'bp-controller' && controller.navigation?.islandId) {
		island = controller.kitchen.design.islands.findById(controller.navigation.islandId);
	}

	const displayOverheadModeFeature = useDisplayOverheadModeFeature();
	const displayPanelModeFeature = useDisplayPanelModeFeature();
	const displaySkuOverheadModeFeature = useDisplaySkuOverheadModeFeature();

	const currentDisplayMode = controller?.navigation?.displayMode;
	let displayMode = displayOverheadModeFeature;

	switch (currentDisplayMode) {
		case DisplayMode.Overhead:
		case DisplayMode.OverheadManufacturing:
		case DisplayMode.SkuOverhead:
		case DisplayMode.SkuOverheadManufacturing:
			displayMode = displayPanelModeFeature;
			break;
		default:
			displayMode = displayOverheadModeFeature;
			break;
	}

	const navFeature: Record<string, Feature<unknown>> = {};
	if (island) navFeature.countertop = showPanelFeature({ controller: controller as unknown as Controller, label: 'countertop' });

	island?.panels.children.forEach((panel) => {
		if (panel.isSidePanel && navFeature.sides) return;
		navFeature[panel.isSidePanel ? 'sides' : panel.type] = showPanelFeature({ controller: controller as unknown as Controller, panelId: panel.id, label: panel.isSidePanel ? 'sides' : panel.label });
	});

	return (
		<Grid width="100%" height="100%" templateRows="auto 1fr">
			<HStack h="35px" w="full" background="blue.400" px={6} py={2} justifyContent={'center'} mb={2}>
				<Text textAlign={'center'} color={'white'} fontSize={18}>{lang.actionPanels.title.navigation}</Text>
			</HStack>
			<VStack w="full" spacing={4} py={2}>
				<Tooltip label={displaySkuOverheadModeFeature.tooltip} aria-label={displaySkuOverheadModeFeature.tooltip}>
					<Button
						width="150px"
						textTransform="capitalize"
						isDisabled={displaySkuOverheadModeFeature.disabled}
						onClick={displaySkuOverheadModeFeature.handler}
						colorScheme={displaySkuOverheadModeFeature.value ? 'green' : undefined}
					>
						{displaySkuOverheadModeFeature.label}
					</Button>
				</Tooltip>
				<Tooltip label={displayMode.tooltip} aria-label={displayMode.tooltip}>
					<Button width="150px" textTransform="capitalize" isDisabled={displayMode.disabled} onClick={displayMode.handler}>
						{displayMode.label}
					</Button>
				</Tooltip>
				{
					Object.keys(navFeature).map((key, i) => (
						<Tooltip key={i} label={navFeature[key].tooltip} aria-label={navFeature[key].tooltip}>
							<Button width="150px" textTransform="capitalize" isDisabled={navFeature[key].disabled} onClick={navFeature[key].handler}>
								{navFeature[key].label}
							</Button>
						</Tooltip>
					))
				}
			</VStack>
		</Grid>
	);
};
